<template>
  <MainHeader></MainHeader>
  <div class="container">
    <!--      <el-menu mode="horizontal" @select="handleSelect">-->
    <div class="left-side">
      <div style="height: 100%">
        <div style="height: 10px"></div>
        <div class="rounded-border">
          <img src="@/assets/picture/userInfo/personalImage.png" alt="个人形象" style="width: 100px;height: 100px"/>
          <p></p>
          {{ loginNickName }}
          <p></p>
          <div style="color: lightgray">欢迎回来</div>
        </div>
        <p></p>
        <div class="rounded-border">
          <el-menu>
            <el-menu-item v-for="menuInfo in userMenuInfos" :key="menuInfo.label" :index="menuInfo.index"
                          :onselect="menuInfo.isSelected" @click="showPage(menuInfo.currentPage)">
              <span style="font-size: 16px">{{ menuInfo.label }}</span>
            </el-menu-item>
          </el-menu>
        </div>
      </div>
    </div>
    <div class="right-side">
      <component :is="currentPage"></component>
    </div>

  </div>

</template>

<script>
import UserInfo from "@/views/userInfo/UserInfo";
import MainHeader from "@/components/MainHeader";
import OrderList from "@/views/userInfo/OrderList";
import examHistory from "@/views/userInfo/examHistory";
import PointCardExchange from "@/views/userInfo/PointCardExchange";
import {ref} from "vue";

let loginNickName = localStorage.getItem("loginNickName");
const userMenuInfos =
    [{index: '/userInfo/UserInfo', label: "个人信息", isSelected: false, currentPage: 'UserInfo'},
      {index: '/userInfo/OrderList', label: "我的订单", isSelected: true, currentPage: 'OrderList'},
      {index: '/userInfo/PointCardExchange', label: "积分兑换", isSelected: false, currentPage: 'PointCardExchange'},
      // {index: '/userInfo/studyHistory', label: "学习追踪", isSelected: false, currentPage: 'studyHistory'},
      {index: '/userInfo/examHistory', label: "考试记录", isSelected: false, currentPage: 'examHistory'},
      {index: '/userInfo/logout', label: "安全登出", isSelected: false, currentPage: ''},
    ]
export default {
  name: "UserInfoHome",
  components: {MainHeader, UserInfo, OrderList, examHistory, PointCardExchange},
  setup() {
    const currentPage = ref('OrderList'); // 默认显示PageA
    return {
      currentPage
    };
  },

  data() {
    return {
      loginNickName: loginNickName,
      userMenuInfos: userMenuInfos
    }
  },
  methods: {
    showPage(page) {
      this.currentPage = page;
    }
  }
}
</script>

<style scoped>
.rounded-border {
  border: 1px solid white; /* 设置边框 */
  border-radius: 10px; /* 设置圆角 */
  padding: 10px;
  width: 200px;
  text-align: center;
  margin-left: 10px;
  background-color: white;
}

.el-menu {
  border-right: 0;
}

.menu {
  width: 240px; /* 左侧宽度 */
  /*border-right: 1px solid #ccc; !* 左右分割线 *!*/
}

.container {
  display: flex;
  background-color: #E7E7E7FF;
}

.left-side {
  flex: 0 0 200px;
  background-color: #E7E7E7FF;
  /*border-right: 1px solid #eee;*/
  /*padding: 20px;*/
  /*width: 200px;*/
}

.right-side {
  flex: 4;
  background-color: #E7E7E7FF;
  /*padding: 20px;*/

}
</style>
